import "./navigation-block.scss";